<template>
  <RevInfoBlock
    class="mt-4"
    :icon="IconInfo"
    :title="i18n(translations.needHelp)"
    variant="default"
  >
    <RevLink target="_blank" :to="TAXUALLY_LINK">
      {{ i18n(translations.taxuallyLinkText) }}
    </RevLink>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconInfo } from '@ds/icons/IconInfo'

import { TAXUALLY_LINK } from './EprDetailsHelp.constants'
import translations from './EprDetailsHelp.translations'

const i18n = useI18n()
</script>
